import { Injectable, signal } from '@angular/core';

const STORAGE_KEY = 'cs.fieldInfoMode';

@Injectable({ providedIn: 'root' })
export class FieldInfoModeService {
  readonly enabled = signal(this.readInitial());

  toggle(): void {
    const next = !this.enabled();
    this.enabled.set(next);
    try {
      localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
    } catch {
      // localStorage indisponível (SSR/sandbox) — silencioso
    }
  }

  private readInitial(): boolean {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  }
}
